import { useOrganization } from "./useOrganization";

export function useTrialStatus() {
  const { organization, isLoading } = useOrganization();

  if (isLoading || !organization) {
    return {
      isTrialExpired: false,
      isTrialExpiringSoon: false,
      daysRemaining: null,
      hasActiveSubscription: false,
      isBetaUser: false,
      isLoading,
    };
  }

  const now = new Date();
  const trialEndsAt = organization.trial_ends_at ? new Date(organization.trial_ends_at) : null;
  const subscriptionStatus = organization.subscription_status;
  const subscriptionPlan = organization.subscription_plan;

  // Check if user is a beta tester
  const isBetaUser = subscriptionPlan === "beta" && trialEndsAt && now < trialEndsAt;

  // Check if user has active subscription
  const hasActiveSubscription = subscriptionStatus === "active" && subscriptionPlan !== "free";

  // If they have active subscription or are a beta user, trial status doesn't matter
  if (hasActiveSubscription || isBetaUser) {
    let daysRemaining: number | null = null;
    
    // Calculate days remaining for beta users
    if (isBetaUser && trialEndsAt) {
      const diffTime = trialEndsAt.getTime() - now.getTime();
      daysRemaining = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    }

    return {
      isTrialExpired: false,
      isTrialExpiringSoon: false,
      daysRemaining,
      hasActiveSubscription: true,
      isBetaUser: !!isBetaUser,
      isLoading: false,
    };
  }

  // Calculate trial expiration
  const isTrialExpired = trialEndsAt ? now > trialEndsAt : false;
  
  let daysRemaining: number | null = null;
  let isTrialExpiringSoon = false;

  if (trialEndsAt && !isTrialExpired) {
    const diffTime = trialEndsAt.getTime() - now.getTime();
    daysRemaining = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    isTrialExpiringSoon = daysRemaining <= 3;
  }

  return {
    isTrialExpired,
    isTrialExpiringSoon,
    daysRemaining,
    hasActiveSubscription,
    isBetaUser: false,
    isLoading: false,
  };
}
